const EXCEL_MIME_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";
export const downloadExcelFile = (filename, content) => {
    const link = document.createElement("a");
    const blob = new Blob([content], { type: EXCEL_MIME_TYPE });
    link.download = `${filename}.xlsx`;
    link.href = URL.createObjectURL(blob);
    link.click();
};
